import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import RoadtripWeekModal from "../roadtripWeekModal";
import { onFormSaved } from "../../formEvents";
import { API_URL } from "../../config/constants";
import ImgRoad from "../../assets/roadtrip/road.png";
import ImgCar from "../../assets/roadtrip/car.png";
import { Road, RoadImage, WeekButton, Car } from "./styles";

// Coordenadas en píxeles de road.png, que es la referencia de todo el dibujo.
const ROAD_W = 802;
const ROAD_H = 291;
const WEEKS = 26;
const STEP = 68;

// La carretera serpentea: 1-9 hacia la derecha, 10-18 de vuelta, 19-26 otra vez a la derecha.
const weekPosition = (week) => {
  if (week <= 9) return { x: 88.5 + STEP * (week - 1), y: 57 };
  if (week <= 18) return { x: 672.5 - STEP * (week - 10), y: 171 };
  return { x: 168.5 + STEP * (week - 19), y: 284 };
};

// El coche se apoya sobre el botón de su semana, y al acabar el tratamiento,
// en el tramo final de la carretera. car.png mira a la izquierda.
const carPosition = (week) => {
  const { x, y } = weekPosition(week);
  return { x, y: y - 17, flip: week <= 9 || week >= 19 };
};
const CAR_FINISHED = { x: 740, y: 288, flip: true };

const percentPosition = ({ x, y }) => ({
  left: `${(x / ROAD_W) * 100}%`,
  top: `${(y / ROAD_H) * 100}%`,
});

const WEEK_NUMBERS = Array.from({ length: WEEKS }, (_, i) => i + 1);

const Roadtrip = () => {
  const { t } = useTranslation();
  const [weeks, setWeeks] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(null);

  useEffect(() => {
    const load = () => {
      fetch(`${API_URL}/me/summary`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
        .then((r) => r.json())
        .then((data) => { if (Array.isArray(data.weeks)) setWeeks(data.weeks); })
        .catch((err) => console.error("Roadtrip summary fetch error:", err));
    };

    load();
    return onFormSaved(({ type }) => { if (type === "weekly") load(); });
  }, []);

  // weeks llega de la primera semana a la que está en curso, en orden.
  // Sin semana en curso y con datos, el tratamiento ya ha terminado.
  const current = weeks.find((week) => week.in_progress);
  let car = null;
  if (current) car = carPosition(current.week_number);
  else if (weeks.length) car = CAR_FINISHED;

  return (
    <Road>
      <RoadImage src={ImgRoad} alt="" />

      {WEEK_NUMBERS.map((number) => {
        const week = weeks[number - 1];
        const finished = week && !week.in_progress;
        return (
          <WeekButton
            key={number}
            type="button"
            style={percentPosition(weekPosition(number))}
            disabled={!finished}
            onClick={() => setSelectedWeek(week)}
            aria-label={t("summary.week", { number })}
          >
            {number}
          </WeekButton>
        );
      })}

      {car && <Car src={ImgCar} alt="" style={percentPosition(car)} $flip={car.flip} />}

      {selectedWeek && (
        <RoadtripWeekModal week={selectedWeek} onClose={() => setSelectedWeek(null)} />
      )}
    </Road>
  );
};

export default Roadtrip;
